import { VoidedObject } from "@/shared/models/voided-object.model";

export class Session extends VoidedObject {
  id?: string;
  sessionTemplate!: string;
  service!: string;
  user!: string;
  attendedBy!: string;
  carer!: string;
  medicalOrder!: string;
  state!: string;
  playbook?: string;
  group!: string;
  formsIdFilled!: string[] | { id: string; name: string }[];
  dateAssigned?: number;
  dateScheduled?: number;
  dateCanceled?: number;
  qualification?: number;
  concept?: string;
  serviceTemplate!: string;
  summary?: string;
  documents!: { name: string; url: string }[];
  numberOrder?: number;
}
